export const facultyData = {
  personalInfo: {
    fullName: 'Dr. Anika Rahman',
    designation: 'Professor',
    department: 'Department of Computer Science & Engineering',
    email: 'anika.rahman@ewubd.edu',
    phone: '+880-2-55046678 Ext: 305',
    officeAddress: 'Room 425, Academic Building, East West University, Dhaka',
    profilePhoto:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1976&auto=format&fit=crop',
    profileUrl: 'https://ewubd.edu/faculty/profile',
  },
  biography:
    'Dr. Anika Rahman is a Professor in the Department of Computer Science & Engineering at East West University. She received her Ph.D. from MIT, focusing on Advanced Neural Architectures for NLP. Her research interests span Machine Learning, Natural Language Processing, Bioinformatics, and Computer Vision. She has published extensively in top-tier conferences and journals and leads several funded research projects.',
  education: [
    {
      degree: 'Ph.D. in Computer Science',
      institution: 'Massachusetts Institute of Technology (MIT)',
      year: '2010',
      details: 'Thesis: Advanced Neural Architectures for NLP',
    },
    {
      degree: 'M.S. in Computer Science',
      institution: 'Stanford University',
      year: '2006',
      details: 'Focus on Artificial Intelligence and Machine Learning',
    },
    {
      degree: 'B.Sc. in Computer Science',
      institution: 'University of Dhaka',
      year: '2003',
      details: 'Graduated with Highest Honors (Gold Medalist)',
    },
  ],
  experience: [
    {
      role: 'Professor',
      organization: 'East West University',
      period: '2018 - Present',
      description:
        'Leading the AI research lab, teaching advanced ML courses, and supervising graduate students.',
    },
    {
      role: 'Associate Professor',
      organization: 'East West University',
      period: '2014 - 2018',
      description:
        'Developed curriculum for Data Science track, secured multiple research grants.',
    },
    {
      role: 'Assistant Professor',
      organization: 'East West University',
      period: '2010 - 2014',
      description:
        'Taught core CS courses, established the NLP research group.',
    },
    {
      role: 'Research Assistant',
      organization: 'MIT CSAIL',
      period: '2006 - 2010',
      description: 'Conducted research on neural machine translation.',
    },
  ],
  researchInterests: [
    'Machine Learning',
    'Natural Language Processing',
    'Bioinformatics',
    'Computer Vision',
    'Deep Learning',
    'Federated Learning',
  ],
  publications: [
    {
      type: 'Journal',
      title:
        'Cross-lingual Transfer Learning for Bengali Natural Language Processing',
      venue: 'IEEE Transactions on Pattern Analysis',
      year: '2025',
      citations: 215,
      authors: 'Rahman, A., Ahmed, S.',
    },
    {
      type: 'Conference',
      title:
        'Deep Reinforcement Learning in Resource Allocation for Edge Computing',
      venue: 'NeurIPS 2024',
      year: '2024',
      citations: 142,
      authors: 'Rahman, A., Khan, M.',
    },
    {
      type: 'Journal',
      title: 'Real-time Object Detection in Medical Imaging',
      venue: 'Medical Image Analysis',
      year: '2024',
      citations: 120,
      authors: 'Hossain, T., Rahman, A.',
    },
    {
      type: 'Conference',
      title: 'Federated Learning for Edge Devices',
      venue: 'ICML 2023',
      year: '2023',
      citations: 89,
      authors: 'Rahman, A., et al.',
    },
    {
      type: 'Journal',
      title: 'Transformer Models for Low-Resource Languages',
      venue: 'Computational Linguistics',
      year: '2022',
      citations: 176,
      authors: 'Rahman, A., Islam, R.',
    },
    {
      type: 'Journal',
      title: 'Genomic Sequence Analysis using Convolutional Neural Networks',
      venue: 'Bioinformatics Journal',
      year: '2021',
      citations: 304,
      authors: 'Rahman, A., Karim, F.',
    },
    {
      type: 'Book',
      title: 'Advanced Machine Learning Techniques',
      venue: 'Springer',
      year: '2020',
      citations: 450,
      authors: 'Rahman, A.',
    },
    {
      type: 'Conference',
      title: 'Attention Mechanisms in Vision Transformers',
      venue: 'CVPR 2019',
      year: '2019',
      citations: 512,
      authors: 'Rahman, A., Davis, L.',
    },
  ],
  projects: [
    {
      title: 'AI-driven Healthcare Diagnostics for Rural Bangladesh',
      fundingSource: 'ICT Division, Govt. of Bangladesh',
      role: 'Principal Investigator',
      period: '2023 - 2025',
      status: 'Ongoing',
    },
    {
      title: 'Bengali NLP Toolkit Development',
      fundingSource: 'University Grants Commission',
      role: 'Principal Investigator',
      period: '2021 - 2023',
      status: 'Completed',
    },
    {
      title: 'Smart Traffic Management System using Edge AI',
      fundingSource: 'World Bank',
      role: 'Co-Investigator',
      period: '2019 - 2021',
      status: 'Completed',
    },
  ],
  awards: [
    {
      title: 'Best Paper Award',
      issuer: 'NeurIPS',
      year: '2024',
    },
    {
      title: 'Outstanding Researcher Award',
      issuer: 'East West University',
      year: '2022',
    },
    {
      title: 'Women in AI Leadership Award',
      issuer: 'TechWomen Asia',
      year: '2020',
    },
    {
      title: 'Gold Medalist (B.Sc.)',
      issuer: 'University of Dhaka',
      year: '2003',
    },
    {
      title: "President's Gold Medal",
      issuer: 'Govt. of Bangladesh',
      year: '2003',
    },
  ],
  skills: [
    {
      category: 'Technical',
      items: ['Python', 'PyTorch', 'TensorFlow', 'C++', 'R'],
    },
    {
      category: 'Research',
      items: [
        'Experimental Design',
        'Statistical Analysis',
        'Grant Writing',
        'Data Visualization',
      ],
    },
    {
      category: 'Teaching',
      items: ['Curriculum Development', 'Mentoring', 'Public Speaking'],
    },
  ],
  memberships: [
    {
      organization: 'IEEE',
      role: 'Senior Member',
      since: '2015',
    },
    {
      organization: 'Association for Computing Machinery (ACM)',
      role: 'Member',
      since: '2010',
    },
    {
      organization: 'Bangladesh Computer Society',
      role: 'Life Member',
      since: '2005',
    },
    {
      organization: 'Women in Machine Learning (WiML)',
      role: 'Board Member',
      since: '2018',
    },
  ],
  certifications: [
    {
      title: 'Deep Learning Specialization',
      issuer: 'Coursera',
      date: '2018',
      credentialId: 'DL-987654',
    },
    {
      title: 'AWS Certified Machine Learning – Specialty',
      issuer: 'Amazon Web Services',
      date: '2021',
      credentialId: 'AWS-ML-123',
    },
    {
      title: 'Google Cloud Professional Data Engineer',
      issuer: 'Google',
      date: '2020',
      credentialId: 'GCP-DE-456',
    },
    {
      title: 'Certified ScrumMaster (CSM)',
      issuer: 'Scrum Alliance',
      date: '2019',
      credentialId: 'CSM-789',
    },
    {
      title: 'Advanced Leadership Program',
      issuer: 'Harvard Business School Online',
      date: '2022',
      credentialId: 'HBS-ALP-001',
    },
  ],
}
